
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/archive/mans-mind",
      function () {
        return require("private-next-pages/archive/mans-mind.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/archive/mans-mind"])
      });
    }
  